import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MemberHubState } from './member-hub.state.interface';

export const selectMemberHubState = createFeatureSelector<MemberHubState>('memberHub');

export const selectMemberProfile = createSelector(selectMemberHubState, (state: MemberHubState) => state.memberProfile);
export const selectMemberPackage = createSelector(selectMemberHubState, (state: MemberHubState) => state.memberPackage);
export const selectMemberActiveCoverage = createSelector(selectMemberHubState, (state: MemberHubState) => state.activeCoverage);
export const selectMemberAppointments = createSelector(selectMemberHubState, (state: MemberHubState) => state.memberAppointments);
